import Axios from "axios";

class UsuarioFiltroDataService {
  findByTela(tela) {
    return Axios.get("usuariosFiltros", { params: { tela } });
  }

  create(params) {
    return Axios.post("usuariosFiltros", params);
  }

  delete(id) {
    return Axios.delete(`usuariosFiltros/${id}`);
  }
}

export default new UsuarioFiltroDataService();
